import { Modal, Select } from 'antd';
import React, { useMemo, useState } from 'react'
import VisitaEstudio from './visita.estudio';
import VisitaSoap from './visita.soap';
import VisitaTratamientoK from './visita.tratamientok';


// PARENT: visitas.jsx

// For creating new visit, it has different forms depending on the type of visit, so this modal will render the form depending on the type of visit selected
// can be estudio, soap, tratamiento ketamina, tratamiento emt, tratamiento tec (in development)
export default function VisitaModal({ id_paciente, isModalOpen, setIsModalOpen, medico }) {

    const [tratamientoSelected, settratamientoSelected] = useState('soap')

    const tratamientos = {
        Estudio: <VisitaEstudio id_paciente={id_paciente} setIsModalOpen={setIsModalOpen} />,
        soap: <VisitaSoap id_paciente={id_paciente} setIsModalOpen={setIsModalOpen} />,
        tratamiento: <VisitaTratamientoK medico={medico} id_paciente={id_paciente} tipo_visita='tratamiento_ketamina' setIsModalOpen={setIsModalOpen} />,
        tratamiento2: <VisitaTratamientoK medico={medico} id_paciente={id_paciente} tipo_visita='tratamiento_emt' setIsModalOpen={setIsModalOpen} />,
        // tratamiento3: <div style={{fontStyle: 'italic'}}>En desarrollo</div>,
    }

    const handleChange = value => {
        console.log(`selected ${value}`);
        settratamientoSelected(value)
    };


    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Modal title="Registrar Nueva Visita" closable={{ 'aria-label': 'Custom Close Button' }} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} destroyOnClose okText="Guardar" width={600} >

            <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center' }}>
                <p style={{ marginTop: 10 }}>Seleccione tipo de visita</p>  <div style={{ width: 10 }}></div>
                <Select
                    value={tratamientoSelected}
                    style={{ width: 200 }}
                    onChange={handleChange}
                    options={[
                        { value: 'Estudio', label: 'Estudio' },
                        { value: 'soap', label: 'SOAP' },
                        { value: 'tratamiento', label: 'Tratamiento Ketamina' },
                        { value: 'tratamiento2', label: 'Tratamiento EMT' },
                        // { value: 'tratamiento3', label: 'Tratamiento TEC' },
                    ]}
                />
            </div>

            <div>Medico: {medico}</div>
            <br />
            <div>
                {tratamientos[tratamientoSelected]}
            </div>

        </Modal>
    )
}

